import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-status-wizard',
  templateUrl: './request-status-wizard.component.html',
  styleUrls: ['./request-status-wizard.component.scss']
})
export class RequestStatusWizardComponent implements OnInit {
@Input() request : any;
  constructor() { }

  ngOnInit() {
  }

  isStepActive(step: number) {
    const stepOrder = ['cq_ws_1', 'cq_ws_2', 'cq_ws_3', 'cq_ws_4', 'cq_ws_5', 'cq_ws_6'];
    return stepOrder.indexOf(this.request?.webStatus) >= step - 1;
  }

  isPrevStep(step: number) {
    const stepOrder = ['cq_ws_1', 'cq_ws_2', 'cq_ws_3', 'cq_ws_4', 'cq_ws_5', 'cq_ws_6'];
    return stepOrder.indexOf(this.request?.webStatus) > step - 1;
  }

}
